import React from "react";
import PropTypes from "prop-types";
import {
  AI_TOOL_NAMES,
  AMPLITUDE_BANNER_DATA_ATTRIBUTES,
  AI_ANSWERS_QUOTA
} from "../../constants";

const LockedInformationBanner = ({ toolName, signupPath }) => {
  const amplitudeDataAttribute = AMPLITUDE_BANNER_DATA_ATTRIBUTES[toolName];

  switch (toolName) {
    case AI_TOOL_NAMES.ASK_AI:
      return (
        <a href={signupPath} data-amplitude={amplitudeDataAttribute}>
          Get {AI_ANSWERS_QUOTA} answers per month
        </a>
      );
    case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
    case AI_TOOL_NAMES.QUIZ_QUESTIONS:
    case AI_TOOL_NAMES.ESSAY_PROMPTS:
      return (
        <>
          Get {AI_ANSWERS_QUOTA} uses of this tool per month with{" "}
          <a href={signupPath} data-amplitude={amplitudeDataAttribute}>
            A<sup>+</sup> Teacher
          </a>
        </>
      );
    default:
      return null;
  }
};

LockedInformationBanner.propTypes = {
  signupPath: PropTypes.string.isRequired,
  toolName: PropTypes.oneOf(Object.values(AI_TOOL_NAMES)).isRequired
};

export default LockedInformationBanner;
